module.exports = __webpack_public_path__ + "img/cam_3_on.0187c6c2.png";